/*
  MIT License

  Copyright (c) 2018 Riad Loukili <rizoox@icloud.com>

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/

import { h, Component } from 'preact'
import Paper from '@material-ui/core/Paper'
import BottomNavigation from '@material-ui/core/BottomNavigation'
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction'

export default class BottomTabs extends Component {

  handleChange = (event, value) => {
    this.props.onChange(value)
  }
  
  render() {
    return (
      <Paper>
        <BottomNavigation style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: 500}} value={this.props.currentPage} onChange={this.handleChange}>
          <BottomNavigationAction label="Generator" value={0} icon={<i className="material-icons">credit_card</i>} />
          <BottomNavigationAction label="Lookup" value={1} icon={<i className="material-icons">search</i>} />
          <BottomNavigationAction label="Saved" value={2} icon={<i className="material-icons">favorite_border</i>} />
          {/* <BottomNavigationAction label="Network" value={3} icon={<i className="material-icons">cloud</i>} /> */}
        </BottomNavigation>
      </Paper>
    )
  }
} 


// WEBPACK FOOTER //
// ./components/BottomTabs/index.js